<template>
    <div class="app-container">
      <el-row class="headTop">
        <el-col :span="22">
          <span v-if="showShop">
          分店：<el-select class="w150 mr20" v-model="shopNum" style="width:200px" clearable placeholder="请选择">
            <el-option v-for="item in this.shopList"
            :key="item.shopNum"
            :label="item.name"
            :value="item.shopNum"
            ></el-option>
          </el-select>
          <el-button style="width:100px; overflow:hidden;" type="primary" @click="queryList()">查询</el-button>
        </span>
        </el-col>
        <el-col :span="2" :offset="showShop?0:22">
          <el-button style="width:100%"   type="success" icon="el-icon-circle-plus-outline" @click="showDialog()">新增</el-button>
        </el-col>
    </el-row>
     <el-dialog :title="addType==2?'修改角色':'新增角色'"  :visible.sync="dialogVisible" width="1000px">
        <el-form :model="formparams" :rules="rules" ref="formparams" label-width="120px">
          <el-form-item label="角色类型" prop="type">
             <el-select v-model="formparams.type" placeholder="请选择">
                <el-option
                v-for="item in this.types"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                ></el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="分店" prop="shopNum" v-if="addType==1&&formparams.type!==3">
             <el-select v-model="formparams.shopNum" placeholder="请选择">
                <el-option
                v-for="item in this.shopList"
                :key="item.shopNum"
                :label="item.name"
                :value="item.shopNum"
                ></el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="职位名称" prop="role">
            <el-input class="w220" v-model="formparams.role" placeholder="请输入职位名称"></el-input>
          </el-form-item>
          
          <el-form-item label="功能模块">
            <el-tag
              style="margin:0 10px"
              :key="index"
              v-for="(item,index) in dynamicTags"
              closable
              :disable-transitions="false"
              @click="changegTitle(item,index)"
              @close="handleClose(item)">
              {{item.name}}
            </el-tag>
          </el-form-item>
          <el-form-item>
            <el-button style="width:100px"  type="primary" @click="addProgevt()">添加分类</el-button>
          </el-form-item>
          <!-- <el-form-item label="选择功能" required>
            <el-tree
              :data="this.empList"
              :props="props"
              ref="tree"
              node-key="id"
              :default-expanded-keys="this.trueList"
              :default-checked-keys="this.trueList"
              show-checkbox>
            </el-tree>
          </el-form-item> -->
          <!-- <el-form-item label="选择功能">
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
            <div style="margin: 15px 0;"></div>
            <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange" style="marginTop:20px;">
                <el-checkbox-button style="margin:10px; border:none" v-for="(item,index) in this.empList" :key="index" :label="item.id" border>{{item.limitname}}
                </el-checkbox-button>
            </el-checkbox-group>
          </el-form-item> -->
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button style="width:100px"  @click="resetForm('formparams')">取 消</el-button>
            <el-button style="width:100px"  type="primary" @click="submitForm('formparams')">确 定</el-button>
        </span>
    </el-dialog>
    <el-dialog title="选择功能"  :visible.sync="dialogVisible2" width="40%">
        <el-form :model="formparams2" :rules="rules2" ref="formparams2" label-width="120px">
          <el-form-item label="分类名" prop="name">
            <el-input class="w220" v-model="formparams2.name" placeholder="请输入分类名称"></el-input>
          </el-form-item>
          <el-form-item label="显示顺序" prop="orderIndex">
            <el-input class="w220" v-model.number="formparams2.orderIndex" placeholder="请输入显示顺序"></el-input>
          </el-form-item>
          <el-form-item label="选择功能">
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
            <div style="margin: 15px 0;"></div>
            <el-checkbox-group v-model="formparams2.checkedCities" @change="handleCheckedCitiesChange" style="marginTop:20px;">
                <el-checkbox-button style="margin:10px;" v-for="(item,index) in this.empList" :key="index" :label="item.limitid" border>{{item.limitname}}
                </el-checkbox-button>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button style="width:100px"  @click="resetForm2('formparams2')">取 消</el-button>
            <el-button style="width:100px"  type="primary" @click="submitForm2('formparams2')">确 定</el-button>
        </span>
    </el-dialog>
    <el-row class="tableList">
      <el-table v-loading="loading" :data="tableData" height="76vh" border stripe>
        <el-table-column
          label="序号"
          type="index"
          width="50">
        </el-table-column>
        <el-table-column prop="remark" label="职位名称"></el-table-column>
        <el-table-column  label="角色类型">
          <template slot-scope="scope">
            <div v-if="scope.row.type==0">教练</div>
            <div v-if="scope.row.type==1">会籍</div>
            <div v-if="scope.row.type==2">店长</div>
            <div v-if="scope.row.type==3">董事长</div>
            <div v-if="scope.row.type==4">会籍主管</div>
            <div v-if="scope.row.type==5">教练主管</div>
          </template>
        </el-table-column>
        <el-table-column label="分店">
          <template slot-scope="scope">
            <div> {{scope.row.shopNum|caseType}} </div>
          </template>
        </el-table-column>
        <el-table-column  label="员工端功能权限">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top" width="500px">
               <div class="menuTree">
                 <div v-for="(item,index) in scope.row.tbModuleList" :key="index">
                  <div>{{item.name}}</div> 
                   <span class="item2" v-for="(item2,index) in item.tbELimitList" :key="index">
                     {{item2.limitname}}
                   </span>
                 </div>
                 <!-- <el-tree :data="scope.row.tbELimit.children"
                :props="defaultPropsmenu">
                </el-tree> -->
              </div>
                <div slot="reference" class="name-wrapper">
                  <el-tag size="medium">鼠标放上查看详情</el-tag>
                </div>
              </el-popover>
              </template>
          </el-table-column>
         <!-- <el-table-column label="管理员身份">
          <template slot-scope="scope">
            <div v-if="scope.row.isadmin==1">是</div>
            <div v-if="scope.row.isadmin==0">否</div>
          </template>
        </el-table-column>
         <el-table-column label="会籍身份">
          <template slot-scope="scope">
            <div v-if="scope.row.isadviser==1">是</div>
            <div v-if="scope.row.isadviser==0">否</div>
          </template>
        </el-table-column> -->
        <el-table-column label="操作" width="300">
          <template slot-scope="scope">
            <el-button style="width:100px"  type="primary" @click="edit(scope.row)">编辑</el-button>
            <el-button style="width:100px"  type="danger" @click="remove(scope.row)">删除</el-button>
            <!-- <el-button style="width:100px"  type="warning" @click="restInfo(scope.row)">休息详情</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </el-row>
  </div>
</template>

<script>
let that;
import {getShops,
  getEmployeeConfigInfo,//查询员工端已配置功能
  insertERole,//新增员工角色
  updateEUserRole,//修改员工角色
  updateInfERole,//修改员工角色信息
  deletefERole,//删除员工角色信息
  getEJtInfo, getInfERole,infeUpdateRole} from "../../api/configApi";
import mainHead from "../../components/mainHead/mainHead";
export default {
  data() {
    return {
      loading: true,
      dialogVisible: false,
      dialogVisible2: false,
      showShop:false,
      hideUpload:false,
      isIndeterminate:false,
      checkAll:false,
      shopList:[],
      shopListAll:JSON.parse(sessionStorage.getItem('shopListAll')),
      titleList:[],
      listIndex:'',
      addList:false,
      dynamicTags:[
      ],
      addType:1,
      formparams:{
        shopNum:'',
        role:'',//员工角色名称
        limitInfo:[],
        id:null,
        type:'',//员工角色类型
        id:'',
      },
      formparams2:{
        name:'',
        orderIndex:'',
        checkedCities:[],
      },
      types:[
        {label:'教练',value:0},
        {label:'会籍',value:1},
        {label:'店长',value:2},
        {label:'董事长',value:3},
        {label:'会籍主管',value:4},
        {label:'教练主管',value:5},
      ],
      newData:null,
      rules:{
        type:[
          { required: true, message: '请选择角色类型', trigger: 'change' }
        ],
        role:[
          { required: true, message: '请输入角色名', trigger: 'blur' }
        ],
        shopNum:[
          { required: true, message: '请选择分店', trigger: 'change' }
        ],
      },
      rules2:{
        name:[
          { required: true, message: '请输入分类名', trigger: 'blur' }
        ],
        orderIndex:[
          { required: true, message: '排序不能为空',trigger: 'blur'},
          { type: 'number',min:0, message: '排序必选是大于或等于0的正整数'}
          // { required: true, type:'number', message: '请输入正整数', trigger: 'blur' }
        ],
      },
      formData:{},
      fileList:[],//图片回显示
      tableData:[],
      shopNum:'',
      empList:[],//会员端功能
      trueList:[],//已经选择的功能
      espJson:[],
      defaultPropsmenu:{
        children: 'children',
        label: 'limitname'
      },
      props: {
        children: 'children',
        label: 'limitname'
      },
    }
  },
  components: {
    mainHead
  },
  beforeCreate(){
    that = this;
  },
  created(){
  },
  filters:{
    caseType(value) {
      if (that.shopListAll.find(i => {
        return i.shopNum == value
        })) {
        return that.shopListAll.find(i => {
            return i.shopNum == value
        }).name
      }
    }
  },
  mounted() {
    this.getShopsList()
    // setTimeout(()=>{
      this.getTableList()
    // },200)
  },
  methods: {
    //查询分店类型
    getShopsList(){
      getShops({isWeb:1}).then((res)=>{
        this.shopList = res.data
        sessionStorage.setItem('shopList',JSON.stringify(res.data))
        if(JSON.parse(sessionStorage.getItem('userinfo')).shopNum!=null){
          this.shopNum = this.shopList[0].shopNum
          this.showShop = false
        } else {
          this.shopNum = ''
          this.showShop = true
        }
      })
    },
    showDialog(){
      this.dialogVisible = true
      this.getEmployeeConfigInfo()
      this.addType =1 
      this.formparams.id= ''
      // this.formparams.ids=[]
      this.dynamicTags = []
      this.formparams.shopNum=''
      this.formparams.role=''//员工角色名称
      this.formparams.type=''//员工角色类型
      this.clearForm('formparams')
    },
    //查询员工端功能
    getEmployeeConfigInfo(){
      getEmployeeConfigInfo().then(res=>{
        if(res.msg == 'success'){
          this.empList = res.data
          // this.espJson = []
          // this.espJson.push({id:res.data.id,limit:res.data.limit,limitname:res.data.limitname,pid:res.data.pid})
        }else{
          this.$message.error(res.message)
        }
      })
    },
    getTableList(){
      getInfERole({shopNum:this.shopNum}).then((res)=>{
        console.log(res)
        this.loading = false
        this.tableData = res.data
      })
    },
    filterHandler(value, row, column) {
      return row.shopNum === value;
    },
    restInfo(row){
      console.log(row)
      this.$router.push({path:'/configurable/teacherRest',query:{id:row.id,name:row.name}})
    },
    //编辑
    edit(row){
      this.addType = 2
      console.log(row)
      this.dialogVisible = true
      // this.formparams.ids = []
      this.formparams.shopNum = row.shopNum
      this.formparams.role = row.remark
      // this.getLastTree(row.tbELimit)
      this.formparams.id = row.id
      this.formparams.type = parseInt(row.type)
      this.dynamicTags = row.tbModuleList 
      // setTimeout(()=>{
        this.getEmployeeConfigInfo()
        this.isIndeterminate =true
      // },200)
      // this.newData = row
      // this.clearForm('formparams')
    },
    //递归过滤员工已经勾选的功能
    getLastTree(list){
      if(list.children){
        for (let i = 0; i < list.children.length; i++) {
          this.getLastTree(list.children[i])
        }
      }else{
        this.trueList.push(list.id)
        console.log(this.trueList)
      }
    },
    submitForm(formparams){
      this.$refs[formparams].validate(valid => {
        if (valid) {
          // this.dynamicTags =
          this.formparams.limitInfo = JSON.stringify(this.dynamicTags)
          if(this.addType == 1){
            insertERole(this.formparams).then(res=>{
              if(res.msg == 'success'){
                  this.$message({
                      type:'success',
                      message:'增加成功'
                  })
                  this.dialogVisible = false
                  // this.formparams.ids = ''
                  this.getTableList()
              }else{
                this.$message({
                  type:'error',
                  message:res.data
                })
              }
            })
          }
          
          if(this.addType == 2){
            // if(this.newData.remark == this.formparams.role){
            //   this.formparams.role = null
            // }
            this.formparams.limitInfo = JSON.stringify(this.dynamicTags)
            updateInfERole(this.formparams).then(res=>{
              if(res.msg == 'success'){
                  this.$message({
                      type:'success',
                      message:'修改成功'
                  })
                  this.dialogVisible = false
                  // this.formparams.ids = ''
                  this.getTableList()
              } else{
                 this.$message({
                    type:'error',
                    message:res.data
                })
              }
            })
          }
        } else {
          this.$message.error('请检查必填项');
          return false;
        }
      });
    },
    remove(row){
       this.$confirm('此操作将删除当前用员工角色下所有的角色及账户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deletefERole({id:row.id}).then(res=>{
          if(res.msg == 'success'){
            this.$message({
              type:'success',
              message:'删除成功'
            })
            this.getTableList()
          }else{
            this.$message.error(res.data);
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });          
      });
    },
    addProgevt(){
      this.formparams2.name=''
      this.formparams2.orderIndex= ''
      this.formparams2.checkedCities=[]
      this.dialogVisible2 = true
      this.addList = true
    },
    changegTitle(item,index){
      this.addList = false
      console.log(item,index)
      this.isIndeterminate = true;
      this.listIndex = index
      if(item.tbELimitList){
          this.formparams2.checkedCities=[]
        for (let i = 0; i < item.tbELimitList.length; i++) {
          // this.formparams2.checkedCities=[]
          this.formparams2.checkedCities.push(item.tbELimitList[i].limitid)
        }
      }else{
        for (let i = 0; i < item.limitid.length; i++) {
          this.formparams2.checkedCities.push(item.limitid[i].limitid)
        }
      }
      this.checkAll = this.formparams2.checkedCities.length === this.empList.length;
      this.formparams2.name = item.name
      this.formparams2.orderIndex = item.orderIndex
      this.dialogVisible2 = true
    },
    submitForm2(formparams2){
      this.$refs[formparams2].validate(valid => {
        if (valid) {
          let limitid = []
          for (let i = 0; i < this.formparams2.checkedCities.length; i++) {
            limitid.push({limitid:this.formparams2.checkedCities[i]})
          }
          if(this.addList){
            this.dynamicTags.push({name:this.formparams2.name,orderIndex:this.formparams2.orderIndex,tbELimitList:limitid})
          }else{
            this.dynamicTags[this.listIndex]={name:this.formparams2.name,orderIndex:this.formparams2.orderIndex,tbELimitList:limitid}
          }
           this.dialogVisible2=false
        }else{
          this.$message.error('请检查必填项');
          return false;
        }
      })
     
    }, 
    //标签
    handleClose(item) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(item), 1);
    },
    
    handleCheckAllChange(val) {
      if(val){
        this.formparams2.checkedCities =[]
        for(var i=0;i<this.empList.length;i++){
          this.formparams2.checkedCities.push(this.empList[i].limitid)
        }
      }else{
        this.formparams2.checkedCities =[]
      }
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.empList.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.empList.length;
    },
    //查询数据
    queryList(){
      this.getTableList()
    },
    //取消
    resetForm(formparams) {
      this.dialogVisible = false;
      this.$refs[formparams].clearValidate();
    },
    resetForm2(formparams) {
      this.dialogVisible2 = false;
      this.$refs[formparams].clearValidate();
    },
    clearForm(formName) {
      if(this.$refs[formName]!=undefined){
        this.$refs[formName].clearValidate();
      }
    }
  }
};
</script>
<style lang="scss">
.menuTree{
  width: 500px;
  overflow: hidden;
  height: auto;
}
.item2{
  display: inline-block;
  padding:5px 10px;
  border: 1px solid skyblue;
  border-radius: 4px;
  margin: 5px;
}
.el-checkbox-button__inner{
  border: 1px solid #DCDFE6 !important;
  border-radius: 4px !important;
  box-shadow: none !important;
}
</style>


// WEBPACK FOOTER //
// member.vue?00bcfe1e